import { HttpContext, HttpContextToken } from '@angular/common/http';

export const SKIP_DELEGATION_CONTEXT = new HttpContextToken<boolean>(() => false);

export function createSkipDelegationContext(): HttpContext {
  return new HttpContext().set(SKIP_DELEGATION_CONTEXT, true);
}

